import React, { Component } from 'react';
import ScreenedImageCover from '../ui/ScreenedImageCover';
import style from './ChapterSectionSplit.module.scss';
import Quote from '../tour/assets/QuotationMark_Red';
import lillianMobile from '../../assets/lillian-wald-mobile.jpg';
class ChapterSectionSplit extends Component {
  state = {
    hideImage: false,
    hideBk: false,
    revealTextBk: false,
    hideGradient: false,
    mobileAdjust: false,
  };

  componentDidMount() {
    TweenLite.to(this.gradientBar, 1, {
      opacity: 1,
    });
    setTimeout(() => {
      this.setState({ revealTextBk: true });
    }, 300);

    // only do mobile position adjust on first slide of this chapter
    if (
      this.props.index === 0 &&
      this.props.location.pathname.indexOf('problems-lead-to-action') !== -1
    ) {
      this.mobileCheck();
      window.addEventListener('resize', this.mobileCheck);
    }

    this.props.setActiveImage(
      this.props.index,
      this.state.mobileAdjust
        ? lillianMobile
        : this.props.sectionData.image.sizes
          ? this.props.sectionData.image.sizes.large
          : this.props.sectionData.images[0].sizes.large
    );
  }
  mobileCheck = () => {
    this.setState({ mobileAdjust: window.innerWidth < 768 });
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.preExit !== nextProps.preExit && nextProps.preExit) {
      // exit animation
      this.preDrawExit();
    }
    if (
      this.props.exitingDrawn !== nextProps.exitingDrawn &&
      nextProps.exitingDrawn
    ) {
      // exit animation
      this.postDrawExit();
    }
  }
  componentWillUnmount() {
    if (
      this.props.index === 0 &&
      this.props.location.pathname.indexOf('problems-lead-to-action') !== -1
    ) {
      window.removeEventListener('resize', this.mobileCheck);
    }
  }
  preDrawExit() {
    // on mobile, have to scroll content back up
    if (window.innerWidth <= 768) {
      TweenLite.to('.fp-section.active .fp-scroller', 0.5, {
        y: this.props.isFirst ? 0 : -window.innerHeight * 0.15,
      });
    }
  }
  postDrawExit() {
    TweenLite.to(this.gradientBar, 0.75, {
      opacity: 0,
    });
    if (window.innerWidth > 768) {
      if (!this.props.isFirst) {
        this.contentEl.style.background = 'transparent';
        this.setState(
          { hideBk: true, hideImage: true, hideGradient: true },
          () => {
            TweenLite.to(this.contentEl, 0.75, {
              opacity: 0,
              ease: 'swoop',
            });
          }
        );
      } else {
        this.setState({ hideImage: true, hideGradient: true }, () => {
          TweenLite.to(this.contentEl, 0.75, {
            opacity: 0,
            ease: 'swoop',
          });
        });
      }
    } else {
      this.setState({ hideImage: true, hideGradient: true }, () => {
        if (this.props.isFirst) {
          TweenLite.to(this.container, 0.75, {
            opacity: 0,
            y: 50,
            ease: 'swoop',
          });
        } else {
          TweenLite.to(this.contentEl, 0.75, {
            opacity: 0,
            y: 50,
            ease: 'swoop',
          });
        }
      });
    }
  }
  render() {
    // console.log(this.props.sectionData.is_quote);
    const { is_quote, attribution } = this.props.sectionData;
    const leftSplit =
      this.props.sectionData.image_alignment === 'left' ? true : false;
    return (
      <div
        className={`section split-section-wrapper ${style.sectionWrapper} ${
          leftSplit ? style.textWrapperLeft : style.textWrapperRight
        } ${this.props.isFirst ? style.firstSection : ''}  ${
          style.bkGradient
        } ${
          this.state.hideGradient ? style.hideGradient : ''
        } chapter-theme--pseudo-bk-gradient`}
      >
        <div
          className={style.flexContainer}
          ref={el => {
            this.container = el;
          }}
        >
          <div
            className={`${this.props.isFirst ? style.frameFull : ''} ${
              style.frame
            }`}
          >
            <ScreenedImageCover
              hide={this.state.hideImage}
              load={this.props.display}
              url={
                this.state.mobileAdjust
                  ? lillianMobile
                  : this.props.sectionData.image.sizes
                    ? this.props.sectionData.image.sizes.large
                    : this.props.sectionData.images[0].sizes.large
              }
            />
            <div
              className={style.gradientBar}
              ref={el => {
                this.gradientBar = el;
              }}
            >
              <div className={style.gradientTop} />
              <div className={style.gradientBottom} />
            </div>
          </div>
          <div
            className={`chapter-split-bg ${style.textWrapper} ${
              this.state.hideBk ? style.hideBk : ''
            } ${this.state.revealTextBk ? style.revealTextBk : ''} ${
              this.props.isFirst && this.state.hideImage
                ? ' forceChapterBk ' + style.forceBk
                : ''
            }`}
            ref={el => {
              this.contentEl = el;
            }}
          >
            <div className={`${style.text} ${is_quote ? 'is-quote' : ''}`}>
              {this.props.sectionData.title && (
                <h2 className="chapter-title-bar">
                  {is_quote && (
                    <div className="split-quote">
                      <Quote />
                    </div>
                  )}
                  {this.props.sectionData.title}
                </h2>
              )}
              <p
                className="chapter-body-text"
                dangerouslySetInnerHTML={{
                  __html: this.props.sectionData.body,
                }}
              />
              {attribution && (
                <p
                  className={style.attribution}
                  dangerouslySetInnerHTML={{
                    __html: `– ${attribution}`,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ChapterSectionSplit;



// WEBPACK FOOTER //
// ./src/components/chapter/ChapterSectionSplit.js